import { useEffect, useState } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Icon, search } from '../Icon/Icon';
import './SimpleSearchFormLoop54.css';

interface SimpleSearchFormLoop54Props {
	onSearch: (query: string) => void;
	initialInputValue?: string | null;
}

export const SimpleSearchFormLoop54 = ({ onSearch, initialInputValue }: SimpleSearchFormLoop54Props): JSX.Element => {
	const t = useTranslation().search;
	const [query, setQuery] = useState<string>(initialInputValue ?? '');

	useEffect(() => {
		if (initialInputValue !== undefined && initialInputValue !== null) {
			setQuery(initialInputValue);
		} else {
			setQuery('');
		}
	}, [initialInputValue]);

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			onSearch(query);
		}
	};

	const handleChange = (q: string) => {
		setQuery(q.slice(0, 100));
	};

	return (
		<div className="simple-search-form-loop">
			<div className="search-wrapper">
				<input
					className="simple-search-input"
					onChange={(e) => handleChange(e.target.value)}
					value={query}
					onKeyDown={handleKeyDown}
					placeholder={t.placeholder || t.searchForProducts}
				/>
				<a className="search-icon" onClick={() => onSearch(query)}>
					<Icon shape={search} size={20} />
				</a>
			</div>
		</div>
	);
};
